import { FormDetails } from '../../../models/FormDetails';

const getFormI18nNamespace = (form: FormDetails | null | undefined): string => {
  const version = form?.version ?? 'v1';
  return `${form?.formComponent}-${version}`;
};

export default getFormI18nNamespace;
